import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { Skeletor } from 'vue-skeletor';
import 'vue-skeletor/dist/vue-skeletor.css';
import {
  isPast, addYears, endOfYear, getYear, parseISO, isValid, format,
} from 'date-fns';
import {
  formatInTimeZone, toZonedTime, fromZonedTime,
} from 'date-fns-tz';
import { Icon } from '../../Atoms';
import { timezone } from '../../envVariables';
import { utcDate, utcDateTime } from '../..';


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePickerCalendar',
  props: {
    id: { default: `datepicker-${Date.now()}` },
    initialDate: {},
    disabled: { type: Boolean, default: false },
    todayText: {},
    dateFormat: {},
    teleportId: {},
    maxDate: {},
    minDate: {},
    isLoading: { type: Boolean, default: false },
    isError: { type: Boolean, default: false }
  },
  emits: ['update:selectedDate'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const now = new Date();
const minDateToUse = computed(() => (props.minDate
  ? parseISO(props.minDate)
  : new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())));

const maxDateToUse = computed(() => (props.maxDate
  ? props.maxDate
  : endOfYear(addYears(utcDateTime(new Date()), 1)).toISOString()));

const emit = __emit;

const localDateValue = ref('');

const selectedDate = computed({
  get: () => localDateValue.value,
  set: (value) => {
    // Always convert the UTC to local time (UK) and use this to build a UTC without the time
    // we only want a date coming out of this
    const ukDate = toZonedTime(value, timezone);
    const dateAsUtc = new Date(
      Date.UTC(ukDate.getFullYear(), ukDate.getMonth(), ukDate.getDate()),
    );

    localDateValue.value = dateAsUtc.toISOString();
    emit('update:selectedDate', localDateValue.value);
  },
});

watch(() => props.initialDate, (value) => {
  localDateValue.value = isValid(parseISO(value))
    ? formatInTimeZone(value, timezone, 'yyyy-MM-dd')
    : utcDate(new Date()).toISOString();
}, { immediate: true });

const formatDate = (date: Date) => {
  // current min date (today) compared to local date time shifted to UK timezone
  if (format(minDateToUse.value, 'yyy-MM-dd') === formatInTimeZone(
    fromZonedTime(
      date,
      timezone,
      { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone },
    ),
    timezone,
    'yyyy-MM-dd',
  )) return props.todayText;
  return formatInTimeZone(
    fromZonedTime(
      date,
      timezone,
      { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone },
    ),
    timezone,
    props.dateFormat,
  );
};

const disabledDates = (date: Date) => (
  toZonedTime(
    date,
    timezone,
    { timeZone: timezone },
  ) ? false : isPast(toZonedTime(
      date,
      timezone,
      { timeZone: timezone },
    ))
);

return (_ctx: any,_cache: any) => {
  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 0 }))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        id: "vueDatepicker",
        class: _normalizeClass(["datepickerCalendar", { 'error': _ctx.isError }])
      }, [
        _createVNode(_unref(Datepicker), {
          id: _ctx.id,
          modelValue: selectedDate.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
          "inline-with-input": "",
          disabled: _ctx.disabled,
          format: formatDate,
          "close-on-auto-apply": true,
          "enable-time-picker": false,
          teleport: _ctx.teleportId,
          "auto-apply": "",
          "input-class-name": "datepickerInput",
          "menu-class-name": "calendarWrapper",
          "calendar-cell-class-name": "calenderItem",
          position: "left",
          placeholder: _ctx.todayText,
          clearable: false,
          "disabled-dates": disabledDates,
          "min-date": minDateToUse.value,
          "max-date": maxDateToUse.value,
          "year-range": [_unref(getYear)(new Date()), _unref(getYear)(_unref(addYears)(new Date(), 2))],
          "prevent-min-max-navigation": "",
          utc: "preserve"
        }, {
          "input-icon": _withCtx(() => [
            _createVNode(_unref(Icon), {
              "icon-name": "calendar",
              md: true
            })
          ]),
          _: 1
        }, 8, ["id", "modelValue", "disabled", "teleport", "placeholder", "min-date", "max-date", "year-range"])
      ], 2))
}
}

})